import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../utils/api";
import { getActiveGlobalRiskConfigEndpoint } from "../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getActiveGlobalRiskConfig = createApi(
  getActiveGlobalRiskConfigEndpoint,
  "GET"
);

const activeGlobalRiskConfigSlice = createSlice({
  name: "activeGlobalRiskConfig",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getActiveGlobalRiskConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActiveGlobalRiskConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getActiveGlobalRiskConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default activeGlobalRiskConfigSlice.reducer;
